<div [attr.data-testid]="testId ?? null">
    <div class="flex-display width-100 flex-direction-row">
        <div class="flex-1 align-content-center">
            <span class="aum-typo-paragraph-l">{{ 'aumico_core_data_grid_accounts' | i18next }} </span>
        </div>
        <div class="search-input flex-1">
            <ham-filter
                [placeholder]="'aumico_core_data_grid_search_placeholder' | i18next"
                [hasFilterButton]="false"
                [autoEmit]="true"
                (filter)="applyFilter($event)"
            ></ham-filter>
        </div>
    </div>

    <!-- 50, 126, 400, 160, 160 -->
    <table mat-table [dataSource]="tableData">
        <ng-container *ngFor="let column of tableColumns">
            <!-- Checkbox Column -->
            <div *ngIf="allowSelection && isASelectColumn(column.name)" class="flex-display flex-row">
                <ng-container [matColumnDef]="column?.name">
                    <th mat-header-cell *matHeaderCellDef class="check-select" style="flex: 50">
                        <mat-checkbox (change)="masterToggle()" [checked]="selection.hasValue() && isAllSelected()">
                        </mat-checkbox>
                    </th>
                    <hr />
                    <td
                        mat-cell
                        *matCellDef="let row"
                        class="check-select"
                        [class.duplicate-cell]="row.isDuplicateAccountNumber"
                    >
                        <mat-checkbox
                            #checkbox
                            (click)="$event.stopPropagation(); clickRow(row, $event)"
                            [checked]="selection.isSelected(row)"
                            (change)="selectRow(row)"
                        >
                        </mat-checkbox>
                    </td>
                </ng-container>
            </div>

            <!-- not Checkbox Column -->
            <div *ngIf="!isASelectColumn(column.name)">
                <ng-container [matColumnDef]="column?.name">
                    <th mat-header-cell *matHeaderCellDef>
                        <ng-container [ngSwitch]="column?.nameType">
                            <div *ngSwitchCase="'date'">
                                {{ column.name | dateLocale }}
                            </div>
                            <div *ngSwitchDefault>{{ capitalize(column?.name) }}</div>
                        </ng-container>
                    </th>

                    <hr />

                    <td mat-cell *matCellDef="let element" [class.duplicate-cell]="element.isDuplicateAccountNumber">
                        <ng-container *ngIf="column.dataType === 'number'">{{
                            (element[column?.dataField] | finNumber) || '-'
                        }}</ng-container>
                        <ng-container *ngIf="column.dataType !== 'number'">
                            <div class="name-container">
                                <span>{{ element[column?.dataField] || '-' }}</span>
                                <span
                                    *ngIf="column.duplicateIcon && element.isDuplicateAccountNumber"
                                    hamIconShapes
                                    icon="assets/hamIcons/split.svg"
                                    [size]="'20px'"
                                    [variant]="'transparent'"
                                    (click)="onDuplicateIconClick(element)"
                                    [hamTooltip]="'aumico_templates_summarized_accounts_unmapped_tooltip' | i18next"
                                    [withArrow]="true"
                                    [backGroundHexColor]="'#1F2A37'"
                                ></span>
                                <span
                                    *ngIf="column.duplicateIcon && element.isSummarized"
                                    hamIconShapes
                                    icon="assets/hamIcons/split.svg"
                                    [size]="'20px'"
                                    [variant]="'primary-active'"
                                    (click)="onUnsummarizedClick(element)"
                                    [hamTooltip]="
                                        'aumico_templates_summarized_accounts_unmapped_tooltip_undo' | i18next
                                    "
                                    [withArrow]="true"
                                    [backGroundHexColor]="'#1F2A37'"
                                ></span>
                            </div> </ng-container
                        ><img
                            *ngIf="cellNameWithRemoveButton === column?.dataField && allowDeleting && element.deletion"
                            class="remove-item"
                            [src]="removeItemSvgUrl"
                            alt="remove-item"
                            (click)="removeSpecificRow(element)"
                        />
                    </td>
                </ng-container>
            </div>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="headers; sticky: true"></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: headers"
            [attr.data-testid]="rowTestIdPrefix != null ? rowTestIdPrefix + row[rowTestIdField] : null"
            [ngClass]="{
                'highlight-row': row.deletion,
                'duplicated-account-row': row.isDuplicateAccountNumber,
                'duplicated-account-row-end': row.isEndOfDuplicateAccounts
            }"
        ></tr>
    </table>

    <div *ngIf="allowDeleting && tableData.data.length !== 0">
        <button
            aum-icon-button
            icon="minus"
            color="basic"
            class="remove-records"
            (click)="removeRows()"
            [disabled]="this.selection.selected.length === 0"
        >
            {{ 'aumico_core_data_grid_remove' | i18next }} {{ removalButtonTextIndicator }}
        </button>
    </div>

    <div class="empty-data-grid">
        <empty-data-grid-feedback *ngIf="tableData.data.length === 0"></empty-data-grid-feedback>
    </div>
</div>
